// import axios from 'axios'
import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { schemaGroup } from '../schemas'
import axios from 'axios'

/**
 * 新增分组
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 分组名称
 * @param {String} options.remark 备注
 */
export const create = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups?projectId=${options.projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data: { detail } } = await axios.post(path, options)
  const { entities } = normalize(detail, schemaGroup)
  return fromJS(entities)
}

/**
 * 删除分组
 * @param {*String} groupId 分组id
 */
export const destroyById = async (groupId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups/${groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  await axios.delete(path)
}

/**
 * 修改分组
 * @param {*String} options.id 分组id
 * @param {String} options.name 分组名称
 * @param {String} options.remark 备注
 */
export const updateById = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups/${options.id}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data: { detail } } = await axios.put(path, options)
  const { entities } = normalize(detail, schemaGroup)
  return fromJS(entities)
}

/**
 * 获取分组列表
 * @param {*String} options.projectId
 */
export const findAll = async (options) => {
  const { projectId } = options
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      projectId
    }
  })
  const { entities } = normalize(data, [ schemaGroup ])
  return fromJS(entities)
}

/**
 * 获取单个分组
 * @param {*String} groupId 分组id
 */
export const findById = async (groupId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups/${groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path)
  const { entities } = normalize(data, schemaGroup)
  return fromJS(entities)
}
/**
 * 获取分组的应用策略信息
 * @param {*String} groupId 分组id
 */
export const getGroupStrategy = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-strategys/strategy-group/${options.groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const {data} = await axios.get(path)
  return data
}
export const getGroupStrategyList = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-strategys/strategy-group-list/${options.groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const {data} = await axios.get(path)
  return data
}
